import { Controller } from "@hotwired/stimulus"
import * as ActiveStorage from "@rails/activestorage";
import { DeviceDataCollector } from "../device_data_collector"

export default class extends Controller {
  static targets = ["loadingOverlay", "submitButton"]
  static values = {
    directUploadUrl: String,
    loadingMessage: { type: String, default: "Processando..." },
    recaptchaSiteKey: String, // v3 site key (checkout forms)
    recaptchaAction: String   // v3 action per flow (checkout forms)
  }

  prepareForm(event) {
    event.preventDefault()

    // Show loading overlay
    this.showLoading()

    // Prepara dados das subcategorias se existir hierarchy controller
    const hierarchyElement = this.element.querySelector('[data-controller*="hierarchy"]')
    if (hierarchyElement) {
      const hierarchyController = this.application.getControllerForElementAndIdentifier(hierarchyElement, 'hierarchy')
      if (hierarchyController) {
        hierarchyController.prepareFormData()
      }
    }

    // Prepara dados do produto se existir product controller
    const productElement = this.element.querySelector('[data-controller*="product"]')
    if(productElement) {
      const productController = this.application.getControllerForElementAndIdentifier(productElement, 'product')
      if(productController) {
        productController.prepareFormData()
      }
    }

    const priceInputs = document.querySelectorAll('[data-mask-type-value="price"]');
    priceInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue
          .replace(/[R$\s]/g, '')
          .replace(/\./g, '')
          
        input.value = cleanValue;
      }
    });

    const percentageInputs = this.element.querySelectorAll('[data-mask-type-value="percentage"]');
    percentageInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue
          .replace(/[%\s]/g, '')
          .replace(/\./g, '')
          
        input.value = cleanValue;
      }
    });

    const phoneInputs = this.element.querySelectorAll('[data-mask-type-value="phone"]')
    phoneInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue.replace(/\D/g, '');
        input.value = cleanValue;
      }
    });

    const cpfInputs = this.element.querySelectorAll('[data-mask-type-value="cpf"]')
    cpfInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue.replace(/\D/g, '');
        input.value = cleanValue;
      }
    });
    
    const cnpjInputs = this.element.querySelectorAll('[data-mask-type-value="cnpj"]')
    cnpjInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue.replace(/\D/g, '');
        input.value = cleanValue;
      }
    });
    
    const cpfCnpjInputs = this.element.querySelectorAll('[data-mask-type-value="cpf_cnpj"]')
    cpfCnpjInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue.replace(/\D/g, '');
        input.value = cleanValue;
      }
    });

    const cardInputs = this.element.querySelectorAll('[data-mask-type-value="card"]')
    cardInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue.replace(/\D/g, '');
        input.value = cleanValue;
      }
    });

    const onlyDigitsInputs = this.element.querySelectorAll('[data-only-digits="true"]')
    onlyDigitsInputs.forEach(input => {
      const formattedValue = input.value;
      if (formattedValue) {
        const cleanValue = formattedValue.replace(/\D/g, '');
        input.value = cleanValue;
      }
    });

    ActiveStorage.start();

    delete this.element.removeAttribute('data-action')
    delete this.element.removeAttribute('data-controller')

    setTimeout(() => {
      this.element.requestSubmit();
    }, 0);
  }

  showLoading() {
    // Show overlay - check target first, then fallback to ID
    if (this.hasLoadingOverlayTarget) {
      this.loadingOverlayTarget.classList.remove("hidden")
    } else {
      // Fallback to finding by ID (for overlays outside the form scope)
      const overlay = document.getElementById("pricing-loading-overlay")
      if (overlay) overlay.classList.remove("hidden")
    }

    // Disable submit button if target exists
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }

    // Also disable all submit buttons in the form
    const submitButtons = this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
    submitButtons.forEach(btn => {
      btn.disabled = true
      btn.classList.add("opacity-50", "cursor-not-allowed")
    })
  }

  hideLoading() {
    if (this.hasLoadingOverlayTarget) {
      this.loadingOverlayTarget.classList.add("hidden")
    } else {
      const overlay = document.getElementById("pricing-loading-overlay")
      if (overlay) overlay.classList.add("hidden")
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    }

    const submitButtons = this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
    submitButtons.forEach(btn => {
      btn.disabled = false
      btn.classList.remove("opacity-50", "cursor-not-allowed")
    })
  }

  async addDeviceData(event) {
    // Re-entrância: o setTimeout(requestSubmit) abaixo redispara este submit.
    // Após a 1ª passagem deixamos enviar nativamente — sem remover data-controller
    // (preservando processing-overlay/recaptcha-fallback) e sem re-mintar token.
    // Cobre o requestSubmit E o re-submit do fallback v2 (que reusa o device_data
    // e o token v2 já gravados no form; o controller persiste pois só o slot é
    // trocado por turbo_stream).
    if (this._prepared) return
    this._prepared = true

    event.preventDefault()

    const siteKey = this.hasRecaptchaSiteKeyValue ? this.recaptchaSiteKeyValue : null
    const action = this.hasRecaptchaActionValue ? this.recaptchaActionValue : null

    const field = document.createElement('input')
    field.type = 'hidden'
    field.name = 'device_data'
    field.value = JSON.stringify(DeviceDataCollector.collect())
    this.element.appendChild(field)

    // Se o fallback v2 está ativo (comprador resolveu o checkbox), o token v2 e a
    // flag recaptcha_v2_fallback já estão no form — não mintar v3 por cima.
    const v2Fallback = this.element.querySelector('input[name="recaptcha_v2_fallback"]')
    if (!v2Fallback && siteKey) {
      try {
        const token = await this.mintRecaptchaV3Token(siteKey, action)
        this.setRecaptchaResponse(token)
      } catch (_e) {
        // Sem token o servidor cai no fallback v2 — seguimos com o submit.
      }
    }

    setTimeout(() => {
      this.element.requestSubmit()
    }, 0)
  }

  mintRecaptchaV3Token(siteKey, action) {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === "undefined") return reject(new Error("grecaptcha unavailable"))
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: action || "submit" }).then(resolve, reject)
      })
    })
  }

  setRecaptchaResponse(token) {
    let input = this.element.querySelector('input[name="g-recaptcha-response"]')
    if (!input) {
      input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'g-recaptcha-response'
      this.element.appendChild(input)
    }
    input.value = token
  }
}